module.exports = __webpack_public_path__ + "static/img/animacion_carga.d13b6a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/animacion_carga.gif
// module id = HxCl
// module chunks = 3